import React from 'react'
import ClientTagging from './general/ClientTagging'
import GainAccess from './general/GainAccess'
import RequestAccess from './general/RequestAccess'
import MoveAccount from './general/MoveAccount'

export default function GeneralTab({
  account, canGainAccess, canRequestAccess, canViewDatabaseUid, flashMessageRef, gainAccessPath, getTenantRequestAccessInfoPath, generalData,
  lastTenantAccessRequest, requestAccessPath, setLastTenantAccessRequest, setLoading, setShowChangePlanModal, canSwitchToMonthlyPlan, validToBeMoved, moveAccountPath, loading
}) {
  return (
    <>
      <div className="card">
        <div className="card-content">
          <div className="flex-box items-center content-space-between">
            <div className="card-title">General</div>
            <ClientTagging
              tag={ generalData?.tag }
            />
          </div>
          <div className="card-body">
            <table>
              <thead>
                <tr><th></th></tr>
              </thead>
              <tbody>
                <tr>
                  <td>{ Support.translations.tenant.flavour }</td>
                  <td>{ Support.translations.module_names[account.flavour.toLowerCase()] }</td>
                </tr>
                <tr>
                  <td>{ Support.translations.package }</td>
                  <td className='flex-box'>
                    { generalData?.formattedPackage }
                    { canSwitchToMonthlyPlan && generalData?.isAnnual == 'true' &&
                      <div className='color-scheme bold pointer m-l-10' onClick={ ()=> setShowChangePlanModal(true)} >{ Support.translations.account.switch_plan_button }</div>
                    }
                  </td>
                </tr>
                <tr>
                  <td>{ Support.translations.columns.nextBillingDate }</td>
                  <td>{ account.next_billing_date }</td>
                </tr>
                { !!generalData?.promotion &&
                  <tr>
                    <td>Active promotion</td>
                    <td>
                      { generalData.promotion }
                    </td>
                  </tr>
                }
                <tr>
                  <td>Status:</td>
                  <td>
                    { generalData?.status }
                  </td>
                </tr>
                <tr>
                  <td>{ Support.translations.account.registration_source }:</td>
                  <td>
                    { generalData?.registrationSource }
                  </td>
                </tr>
                { (!!account.paymentType || !!generalData?.typeOfPayment) &&
                  <tr>
                    <td>{ Support.translations.account.type_of_payment }:</td>
                    <td>
                      { (account.paymentType || generalData?.typeOfPayment) }
                    </td>
                  </tr>
                }
                <tr>
                  <td>{ Support.translations.account.attributes.name }:</td>
                  <td>{ account.name || '-' }</td>
                </tr>
                { canViewDatabaseUid && !!generalData &&
                  <tr>
                    <td>{ Support.translations.account.database_uid }:</td>
                    <td>
                      <a href={ generalData.directorsUrl } target='_blank'>
                        { `id: ${ generalData.accountId }, uid: ${ account.account_uid }` }
                        <i className='fa-light fa-arrow-up-right-from-square m-l-5' />
                      </a>
                    </td>
                  </tr>
                }
                <tr>
                  <td>{ Support.translations.account.attributes.domain }:</td>
                  <td>{ account.domain || '-' }</td>
                </tr>
                <tr>
                  <td>Subdomain:</td>
                  <td>
                    <a href={ generalData?.subdomainRedirect } target='_blank' >
                      { generalData?.subdomain }
                      <i className='fa-light fa-arrow-up-right-from-square m-l-5' />
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>{ `${ Support.translations.role.attributes.key.superadmin } ${ Support.translations.administrator.attributes.email }:` }</td>
                  <td>
                    { account.email }
                  </td>
                </tr>
                <tr>
                  <td>{ `${ Support.translations.role.attributes.key.superadmin } ${ Support.translations.administrator.attributes.name }:` }</td>
                  <td>
                    { generalData?.formattedName }
                  </td>
                </tr>
                <tr>
                  <td>Created at</td>
                  <td>{ account.registeredAt }</td>
                </tr>
                <tr>
                  <td>Trial started at</td>
                  <td>{ account.trialStartDate }</td>
                </tr>
                <tr>
                  <td>Trial ends at</td>
                  <td>{ account.trialEndDate }</td>
                </tr>
                <tr>
                  <td>Confirmed email</td>
                  <td className='flex-box items-center'>
                    { !!generalData &&
                      <>
                        { generalData.confirmedEmail
                          ? <i className='fa-light fa-check' />
                          : '-'
                        }
                      </>
                    }
                  </td>
                </tr>
                <tr>
                  <td>Onboarding completed</td>
                  <td className="flex-box items-center">
                    { generalData &&
                      <>
                        { generalData.hasReceivedTour
                          ? <i className='fa-light fa-check' />
                          : '-'
                        }
                      </>
                    }
                  </td>
                </tr>
                <tr>
                  <td>Onbarding dismissed</td>
                  <td>
                    { generalData &&
                      <>
                        { generalData.tourDismissed
                          ? <i className='fa-light fa-check' />
                          : '-'
                        }
                      </>
                    }
                  </td>
                </tr>
                <tr>
                  <td>Card added</td>
                  <td>
                    { generalData &&
                      <>
                        { generalData.cardsAdded
                          ? <i className='fa-light fa-check' />
                          : '-'
                        }
                      </>
                    }
                  </td>
                </tr>
                { canRequestAccess && lastTenantAccessRequest?.access_type !== 'gain_access' &&
                  <tr>
                    <td>Admin Access Request</td>
                    <td className="flex-box items-start content-start">
                      { !!generalData &&
                        <RequestAccess
                          account={ account }
                          flashMessageRef={ flashMessageRef }
                          requestAccessPath={ requestAccessPath }
                          getTenantRequestAccessInfoPath={ getTenantRequestAccessInfoPath }
                          latestTenantAccessRequest={ lastTenantAccessRequest }
                          setLatestTenantAccessRequest={ setLastTenantAccessRequest }
                          setLoading={ setLoading }
                        />
                      }
                    </td>
                  </tr>
                }
                { canGainAccess && lastTenantAccessRequest?.access_type !== 'request_access' &&
                  <tr>
                    <td>Admin Access</td>
                    <td className="flex-box items-start content-start">
                      { !!generalData &&
                        <GainAccess
                          account={ account }
                          flashMessageRef={ flashMessageRef }
                          gainAccessPath={ gainAccessPath }
                          getTenantRequestAccessInfoPath={ getTenantRequestAccessInfoPath }
                          latestTenantAccessRequest={ lastTenantAccessRequest }
                          setLatestTenantAccessRequest={ setLastTenantAccessRequest }
                          setLoading={ setLoading }
                        />
                      }
                    </td>
                  </tr>
                }
                { validToBeMoved && !account.migrationStatus &&
                  <tr>
                    <td>Move Account</td>
                    <td className="flex-box items-start content-start">
                      <MoveAccount
                        account={ account }
                        moveAccountPath={ moveAccountPath }
                        flashMessageRef={ flashMessageRef }
                        setLoading={ setLoading }
                        loading={ loading }
                      />
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>

      { generalData?.contactNotes &&
        <div className="card">
          <div className="card-content">
            <div className="card-title">
              Contact notes
            </div>
            <div className="card-body m-t-10">
              { generalData.contactNotes }
            </div>
          </div>
        </div>
      }

      <div className="card">
        <div className="card-content">
          <div className="card-title">
            Domain Information
          </div>
          <div className="card-body">
            <table>
              <thead>
                <tr>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{ Support.translations.account.attributes.domain }</td>
                  <td>
                    { account.domain }
                  </td>
                </tr>
                <tr>
                  <td>Subdomain</td>
                  <td>
                    { generalData?.subdomain }
                  </td>
                </tr>
                <tr>
                  <td>SSL Key</td>
                  <td>
                    { generalData?.sslKey }
                  </td>
                </tr>
                <tr>
                  <td>SSL Certificate</td>
                  <td>
                    { generalData?.sslCrt }
                  </td>
                </tr>
                <tr>
                  <td>SSL CA-Bundle</td>
                  <td>
                    { generalData?.sslCaBundle }
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  )
}